import { useCssVars as _useCssVars, defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-c62f4274"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "container" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "camera" }, null, -1))
const _hoisted_3 = { class: "text" }

import { useInfo } from '@/store';
import { storeToRefs } from 'pinia';
import { useBackgroundUrl } from '@/components/workshop/useWorkshopImg';
// components
import Button, { WorkShopButton } from './index';


export default /*#__PURE__*/_defineComponent({
  __name: 'ShareButton',
  setup(__props) {

_useCssVars(_ctx => ({
  "a038374c": (_unref(iconCamera).mobile)
}))

const { iconCamera } = useBackgroundUrl();
const { translations } = storeToRefs(useInfo());

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(Button), {
    class: "share-btn",
    type: _unref(WorkShopButton).Share
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _hoisted_2,
        _createElementVNode("span", _hoisted_3, _toDisplayString(_unref(translations)?.['IW_P4_SHARE']), 1)
      ])
    ]),
    _: 1
  }, 8, ["type"]))
}
}

})